// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"tS-z","categoryName":"uS-z","categoryNameSearchHeader":"vS-z","categoryContent":"wS-z","bottomAligned":"xS-z","image":"yS-z","imageNoBackground":"zS-z"};